var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":_vm.$t('common.reports')}},[_c('div',[_c('b-tabs',{attrs:{"content-class":"mt-3","pill":"","pills":"","card":""}},[_c('Surgeries')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }